import * as Sentry from '@sentry/vue'
import { auth } from '@/firebase'

/**
 * TEMPORARY debug allowlist for the Skroutz infinite-spinner investigation.
 * Remove this file (and call sites) once the issue is diagnosed.
 */ 
/** Partial email substrings — any address containing these is logged. */
const BOT_FLOW_DEBUG_EMAIL_MATCHES = ['skroutz', 'cyces']

export function shouldLogBotRecordingFlow(email = auth.currentUser?.email) {
  if (!email) return false
  const normalized = String(email).toLowerCase()
  return BOT_FLOW_DEBUG_EMAIL_MATCHES.some((match) => normalized.includes(match))
}

/** Prefer host only — avoid shipping full meeting URLs to Sentry. */
export function safeMeetingHost(meetingUrl) {
  if (!meetingUrl || typeof meetingUrl !== 'string') return null
  try {
    return new URL(meetingUrl.trim()).host || 'invalid-url'
  } catch (_) {
    return 'unparseable-url'
  }
}

/**
 * Breadcrumb + searchable Sentry message for one step of the bot invite flow.
 * No-ops unless the signed-in email partially matches BOT_FLOW_DEBUG_EMAIL_MATCHES.
 * Pass `email` in data when auth.currentUser may not be ready yet (e.g. early auth callback).
 */
export function logBotRecordingStep(step, data = {}) {
  const email = data.email || auth.currentUser?.email
  if (!shouldLogBotRecordingFlow(email)) return

  const uid = data.user_id || auth.currentUser?.uid
  const payload = {
    ...data,
    email,
    user_id: uid,
  }

  Sentry.addBreadcrumb({
    category: 'bot-recording',
    message: step,
    level: 'info',
    data: payload,
  })

  Sentry.withScope((scope) => {
    scope.setTag('workflow', 'bot-recording')
    scope.setTag('bot_step', step)
    scope.setLevel('info')
    if (uid || email) {
      scope.setUser({
        id: uid,
        email: email || undefined,
      })
    }
    scope.setExtra('bot_flow', payload)
    Sentry.captureMessage(`[bot-recording] ${step}`)
  })
}
